module.exports = __webpack_public_path__ + "media/hallBgm.6b20b952.mp3";